<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
    <div class="box">
      <div class="columns">
        <div class="column">
          <BInputWithValidation
            rules="required|max:100"
            :disabled="disabled"
            type="text"
            label="Organisation"
            v-model="org.name"
          />
        </div>
        <div class="column is-4" v-if="!disabled">
          <BInputWithValidation
            rules="max:20"
            type="text"
            label="Abkürzung"
            v-model="org.abbreviation"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <BInputWithValidation
            rules="max:50"
            type="text"
            label="Straße"
            v-model="org.street"
          />
        </div>
        <div class="column is-3">
          <BInputWithValidation
            rules="max:5"
            type="number"
            label="Nr."
            v-model="org.house_no"
          />
        </div>
        <div class="column is-3">
          <BInputWithValidation
            rules="max:50"
            type="text"
            label="Zusatz"
            v-model="org.street_additional"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column is-3">
          <BInputWithValidation
            rules="min:5|max:50"
            type="text"
            label="PLZ"
            v-model="org.zip_code"
          />
        </div>
        <div class="column">
          <BInputWithValidation
            rules="max:30"
            type="text"
            label="Stadt"
            v-model="org.city"
          />
        </div>
      </div>
      <div class="columns" v-if="!disabled">
        <div class="column">
          <BInputWithValidation
            rules="max:500"
            type="textarea"
            label="Notiz"
            v-model="org.comment"
          />
        </div>
      </div>
    </div>
    <div class="block" v-if="error">
      <b-message type="is-danger">
        <span v-html="error" />
      </b-message>
    </div>
    <div class="is-flex is-justify-content-end">
      <b-button
        type="is-gold"
        :disabled="invalid"
        @click="handleSubmit(submit)"
      >
        Speichern
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'UserSimple',
  components: {
    BInputWithValidation,
  },
  props: {
    org: {
      required: true,
    },
    disabled: {
      required: false,
      default: true,
    },
    comment: {
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      error: 'org/error',
      meUser: 'user/me',
    }),
  },
  methods: {
    submit() {
      if (this.disabled) {
        this.$emit('submit', {
          id: this.org.id,
          street: this.org.street,
          house_no: this.org.house_no,
          street_additional: this.org.street_additional,
          zip_code: this.org.zip_code,
          city: this.org.city,
          comment: this.org.comment,
          abbreviation: this.org.abbreviation,
        });
      } else {
        this.$emit('submit', {
          id: this.org.id,
          name: this.org.name,
          street: this.org.street,
          house_no: this.org.house_no,
          street_additional: this.org.street_additional,
          zip_code: this.org.zip_code,
          city: this.org.city,
          comment: this.org.comment,
          abbreviation: this.org.abbreviation,
        });
      }
    },
  },
};
</script>
